// ? cookies and other mandatory global scripting
//import "./misc/nu-globals";
// ? scrolling animations with GSAP
// import "./scrolltrigger";
// ? hook into Swiper.JS instances created by Gutenslider
//import "./blocks/gutenslider";
// ? extensions for the accordion block - working on the block itself is hard!
import "./blocks/accordion";
// ? extensions for the tabs block -- (ultimate blocks tabbed content)
// import "./blocks/tabs";
// ? extensions for the image/gallery blocks including magnific popup hooks
import "./blocks/image-and-gallery";
// ? experimental code temporarily held here
import "./misc/_experimental";
//
//import "./_posts-grid-block-as-swiper";
//
//
(function ($, window, document) {
	// ? throttling vs. debouncing is that throttle guarantees the execution of the function
	// * limits function calls to once per time delay / duration
	const debounce = function (func, delay) {
		let timer;
		return function () {
			//anonymous function
			const context = this;
			const args = arguments;
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(context, args);
			}, delay);
		};
	};
	// * limits function calls to wait until limit / timer
	const throttle = (func, limit) => {
		let inThrottle;
		return function () {
			const args = arguments;
			const context = this;
			if (!inThrottle) {
				func.apply(context, args);
				inThrottle = true;
				setTimeout(() => (inThrottle = false), limit);
			}
		};
	};





	/**
	 * mQHandler maps JS event onto our breakpoints nicely.
	 * use this to fire scripts when we cross over a breakpoint threshold
	 */
	const mqHandler = {
		//
		breakpoints: {
			phone: "600px",
			small: "780px",
			medium: "1024px",
			large: "1250px",
			xlarge: "1620px",
			huge: "1920px",
		},
		_instance: function () {
			// pass this into the window so other files can access it
			return (window.mqHandler = mqHandler);
		},

		_init: function (overFunction = {}, underFunction = {}) {
			for (const [key, value] of Object.entries(this.breakpoints)) {
				let listener = window.matchMedia("(max-width: " + value + ")");
				listener.addEventListener("change", (event) => {
					if (event.matches) {
						if (underFunction._init) {
							underFunction._init(event, key);
						}
					} else {
						if (overFunction._init) {
							overFunction._init(event, key);
						}
						//
					}
				});
			}
		},
	};





//temporary. preload first image on home page.
	// function preload_image(im_url) {
	// 	let img = new Image();
	// 	img.src = im_url;
	// }
	// if ($("body").hasClass("home")) {
	// 	preload_image("../wp-content/uploads/home-hero-large.webp");
	// }




	//Controls pop up form on /current-initiatives/creative-living-award/
if ( $( ".open-popup-link" ).length ) {
	$('.open-popup-link').magnificPopup({
		type: 'inline',
		midClick: true,
		mainClass: 'mfp-zoom-in'
	});
}


//open nomiation form if hash value equals
// $(function() {
// 	if (location.hash === "#wpforms-6263") {
// 		$.magnificPopup.open({
//       items: {
//           src: '#wpforms-6263',
//           type: 'inline'
//       }
//     });
// 	}
// });
// Open nomination form if hash matches
(function($) {
    function openNominationForm() {
        $.magnificPopup.open({
            items: {
                src: '#wpforms-6263',
                type: 'inline'
            }
        });
    }

    function checkHashAndOpen() {
        if (location.hash === '#wpforms-6263') {
            openNominationForm();
        }
    }

    $(function() {
        // Run on initial page load
        checkHashAndOpen();

        // Run when the hash changes (clicking the nav link again on same page)
        $(window).on('hashchange', checkHashAndOpen);

        // Handle clicking the nav link when the hash is already set
        // (clicking #wpforms-6263 while already on /page/#wpforms-6263 won't fire hashchange)
        $('a[href$="#wpforms-6263"]').on('click', function(e) {
            var linkPath = this.pathname.replace(/\/$/, '');
            var currentPath = window.location.pathname.replace(/\/$/, '');

            if (linkPath === currentPath && location.hash === '#wpforms-6263') {
                e.preventDefault();
                openNominationForm();
            }
        });
    });
})(jQuery);



//masonry grid on news page//
if ( $( ".is-style-news-masonry > div > ul.nu_news" ).length ) {
	$('.is-style-news-masonry > div > ul.nu_news').masonry({
		// options
		// columnWidth: 413,
		// horizontalOrder: true,
		// gutter: 30

		percentPosition: true,
		columnWidth: '.grid-sizer',
    gutter: '.gutter-sizer',
		horizontalOrder: true
	});
}





		//
		// ... code in here will run after jQuery says document is ready
		//

})(window.jQuery, window, document);
